import React, { ReactElement, useContext } from 'react';
import { Responsive } from '@wds/responsive';
import { Immutable } from '@wds/utils';
import { ThemeName, Brand, Session } from './types';
import { VARIANTS, VariantKey } from './variants';
import { Actions } from './components/actions';
import { MobileNav } from './components/mobile-nav';
import { NavBar } from './components/nav-bar';
import { Navigation } from './components/navigation';
import { Title } from './components/title';
import { Logo } from './components/logo';

import useStyles from './useStyles';
import { withHeaderTheme } from './theme';

import HeaderContext from './HeaderContext';
import { StaticContext } from '../../..';

export type HeaderProps = Immutable<{
  isEUDC: boolean;
  // TODO: Better define this type
  lang: string;
  variant?: VariantKey;
  title?: string;
  session?: Session;
}>;

const HeaderContent = ({
  isEUDC,
  lang,
  variant = 'default',
  title = '',
  session,
}: HeaderProps): ReactElement => {
  const classes = useStyles();
  const { HEADER_EXP = {} } = useContext(StaticContext);
  const { isThemeTreatment = false } = HEADER_EXP;
  const themeTreatment: Brand = isThemeTreatment ? 'Momentive' : 'SurveyMonkey';

  const headerVariant = VARIANTS[variant];

  const headerBrand = headerVariant.brand ?? themeTreatment;
  const headerTitle = title || headerVariant.title;

  return (
    <HeaderContext.Provider value={{ isEUDC, lang }}>
      <NavBar>
        <MobileNav
          brand={headerBrand}
          navItems={headerVariant.menu}
          userMenu={headerVariant.user}
          link={headerVariant.homePage}
          infoMenu={headerVariant.info}
        />
        <Responsive minWidth="md">
          <>
            <span className={classes.navSection}>
              <Responsive minWidth="xl">
                <Logo brand={headerBrand} link={headerVariant.homePage} />
              </Responsive>
              <Responsive minWidth="xl">
                <>
                  {headerTitle && <Title>{headerTitle}</Title>}
                  <Navigation items={headerVariant.menu} />
                </>
              </Responsive>
            </span>
            <span className={classes.navSection}>
              {headerVariant.actions && (
                <Actions items={headerVariant.actions} />
              )}
              <Responsive minWidth="xl">
                <>
                  {headerVariant.info}
                  {headerVariant.user}
                </>
              </Responsive>
            </span>
          </>
        </Responsive>
      </NavBar>
    </HeaderContext.Provider>
  );
};

const HeaderWithTheme = withHeaderTheme(HeaderContent);

const Header = (props: HeaderProps) => {
  const { HEADER_EXP = {} } = useContext(StaticContext);
  const { isThemeTreatment = false } = HEADER_EXP;

  const themeTreatment: ThemeName = isThemeTreatment ? 'elevate' : 'wrench';

  return <HeaderWithTheme theme={themeTreatment} {...props} />;
};

export default Header;
export { Header };
